/** DOM attribute Playwright waits for before screenshot/PDF capture. */
export const REPORT_CAPTURE_READY_ATTR = 'data-report-capture-ready';

/** Max wait before signaling capture ready (matches backend timeout). */
export const CAPTURE_READY_TIMEOUT_MS = 90_000;

/** Query param set by preview-capture and pdf-export Lambdas. */
export const CAPTURE_QUERY_PARAM = 'capture';

export function isCaptureMode(
	search: string = typeof window !== 'undefined'
		? window.location.search
		: ''
): boolean {
	return new URLSearchParams(search).get(CAPTURE_QUERY_PARAM) === '1';
}

export function parseCaptureTokenFromUrl(
	search: string = typeof window !== 'undefined'
		? window.location.search
		: ''
): string | null {
	if (!isCaptureMode(search)) {
		return null;
	}
	return new URLSearchParams(search).get('token');
}
